import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

const PublicRoute = ({
  isAuthenticated,
  isAssociateAuthenticated,
  component: Component,
  user,
  isImpersonating,
  ...rest
}) => {
  console.log(
    "[PublicRoute] Render - isAuthenticated:",
    isAuthenticated,
    "isImpersonating:",
    isImpersonating,
    "path:",
    rest.path,
    "\n[PublicRoute] User:",
  );
  console.dir(user);
  console.log("[PublicRoute] Component:", Component);
  const redirectPath = user?.redirect_url ?? user?.role?.redirect_url ?? "/";
  if (isAuthenticated)
    console.log(
      "[PublicRoute] User is authenticated, redirecting to:",
      redirectPath,
    );
  return (
    <Route
      {...rest}
      render={(props) =>
        isImpersonating ? (
          <Component {...props} />
        ) : isAuthenticated ? (
          redirectPath !== "/login" ? (
            <Redirect to={redirectPath} />
          ) : (
            <Component {...props} />
          )
        ) : isAssociateAuthenticated ? (
          <Redirect to={"/sys_company_administrator"} />
        ) : (
          <Component {...props} />
        )
      }
    />
  );
};

const mapStateToProps = (state) => ({
  user: state.app.user,
  isAuthenticated: !!state.app.user,
  isAssociateAuthenticated: !!state.app?.superAdmin?.associate,
  isImpersonating: state.app.impersonate_mode,
});

export default connect(mapStateToProps)(PublicRoute);
